import React, {useEffect, useState} from "react";
import moment from "moment";
import numeral from "numeral";
import NumberFormat from "react-number-format";
import { Card, CardContent, Typography, Button, List } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import CardHeader from "@material-ui/core/CardHeader/CardHeader";
import clientSnapshot from "../../../pages/client/ClientProfile/images/client_snapshot.svg";
import {asDbDateFormat, DATE_FORMAT_SERVICE_DASHBOARD} from "../../../utils/dateUtils";
import {history} from "../../../configureStore";
import {useActions} from "../../../actions";
import * as AccountActions from "../../../actions/account";
import {
    getCurrentPolicyYear,
    nextAnniversaryDate,
    getIndexOfCompletedYear,
    completedPolicyYear
} from "../../../pages/clientServicing/ClientServiceDashbaord";
import {usePolicyContext} from "./PolicyContext";
import {getPaymentAmount} from "../../../model/payment";

export default function QuickView() {
    const accountActions = useActions(AccountActions);
    const clientCaseDetails = useSelector((state: RootState) => state.clientCaseDetails);
    const profile: any = useSelector((state: RootState) => state.profile);
    const issueDate = clientCaseDetails && clientCaseDetails.tranche && clientCaseDetails.tranche.issueDate;
    let completedYearPolicyBreakDown:any = [];
    let currentYearContributionAmountDue:any = 0;
    let currentYearPaymentReceived:number = 0;
    let agentName: string = "";
    let employerContribution: number = 0;
    let carrierName: string = "";
    let deathBenefit: string;
    let employer: string = "N/A";
    let companyName: string = ""
    let netCashValue:number;
    let bankLoanAmount: number;
    let potentialIncomeStartAge:number = 65;
    let potentialIncomeEndAge:number = 90;
    let anniversaryDate = nextAnniversaryDate(issueDate);
    let policyCompletedYearIndex:number = getIndexOfCompletedYear(issueDate);
    const completedPolicyYearCount = completedPolicyYear(issueDate);
    let currentAnniversaryYear = getCurrentPolicyYear(anniversaryDate);
    let isEmployerContribution:boolean = false;
    let estimatedAnnualIncome: number = clientCaseDetails && clientCaseDetails.benefitAmounts && clientCaseDetails.benefitAmounts.estimatedAnnualIncome || 0;
    const clientPolicy = profile && profile.client && profile.client.clientPolicies && profile.client.clientPolicies.length > 0 && profile.client.clientPolicies[0];
    if (profile && profile.client) {
        agentName = `${clientPolicy.agent.user.firstName} ${clientPolicy.agent.user.lastName}`;
        employerContribution = numeral(clientPolicy.employerContribution).value() || 0;
        carrierName = clientPolicy.carrier.carrierName;
        employer = clientPolicy.employer || "N/A";
        if(clientPolicy.company){
            companyName = clientPolicy.company.companyName;
        }
    }
    const { policyBreakDowns, benefitAmounts } = clientCaseDetails;
    if(clientCaseDetails){
        if(policyBreakDowns && currentAnniversaryYear) {
            completedYearPolicyBreakDown = policyBreakDowns && policyBreakDowns[policyCompletedYearIndex];
            if (completedYearPolicyBreakDown) {
                currentYearContributionAmountDue = numeral(completedYearPolicyBreakDown && completedYearPolicyBreakDown.clientContributionDue).value();
            }
            if (completedYearPolicyBreakDown && completedYearPolicyBreakDown.payments && completedYearPolicyBreakDown.payments.length > 0) {
                completedYearPolicyBreakDown.payments.map((payment: any) => {
                    currentYearPaymentReceived += numeral(payment && payment.amount).value()
                })
            }
            if (currentYearPaymentReceived >= currentYearContributionAmountDue) {
                currentYearPaymentReceived = currentYearContributionAmountDue;
            }
            potentialIncomeStartAge = benefitAmounts && benefitAmounts.incomeStartAge;
            potentialIncomeEndAge = benefitAmounts && benefitAmounts.incomeEndAge;
            isEmployerContribution = !!(policyBreakDowns && policyBreakDowns[0] && (policyBreakDowns[0].employerContributionReceived > 0));
        }
    }

    netCashValue = completedYearPolicyBreakDown && completedYearPolicyBreakDown.actualNetSurrenderValue || completedYearPolicyBreakDown && completedYearPolicyBreakDown.netLoanCashValueIllustrated || 0;
    deathBenefit = completedYearPolicyBreakDown && completedYearPolicyBreakDown.netDeathBenefitActual || completedYearPolicyBreakDown && completedYearPolicyBreakDown.illustratedNetDeathBenefit || 0;
    bankLoanAmount = completedYearPolicyBreakDown && completedYearPolicyBreakDown.bankLoanAmount || completedYearPolicyBreakDown && completedYearPolicyBreakDown.estLoanBalance || 0;
    const currentYear = completedYearPolicyBreakDown && completedYearPolicyBreakDown.policyYear || "";
    const nextYear = policyBreakDowns && policyBreakDowns[policyCompletedYearIndex + 1] && policyBreakDowns[policyCompletedYearIndex + 1].policyYear || "";
    const yearBetween:string = `${currentYear} - ${nextYear}`;

    const [paymentFrequency, setPaymentFrequency] = useState(clientPolicy && clientPolicy.paymentFrequency || "annual");


    const {policy}: any = usePolicyContext();
    const [nextContributionDate, setNextContributionDate] = useState("");
    const [nextContributionAmount, setNextContributionAmount] = useState(0);
    useEffect(() => {
        if (policy && policy.paymentSchedule) {
            if (policy.paymentSchedule.type === 'AnnualEnrollment' && policy.paymentTimetableAnnual && policy.paymentTimetableAnnual.switchPayment) {
                if (policy.paymentTimetableAnnual && policy.paymentTimetableAnnual.nextPayment) {
                    setNextContributionDate(policy.paymentTimetableAnnual.nextPayment.date);
                    setNextContributionAmount(getPaymentAmount(policy.paymentTimetableAnnual.nextPayment));
                }
                setPaymentFrequency("annual");
            } else  if (policy.paymentSchedule.type === 'MonthlyEnrollment' || policy.paymentSchedule.type === 'AnnualToMonthly') {
                if (policy.paymentTimetableMonthly && policy.paymentTimetableMonthly.nextPayment) {
                    setNextContributionDate(policy.paymentTimetableMonthly.nextPayment.date);
                    setNextContributionAmount(getPaymentAmount(policy.paymentTimetableMonthly.nextPayment));
                }
                setPaymentFrequency("monthly");
            }
        }
    }, [policy]);

    return (
            <Card className="customCard boxShadow w100 mb20">
                <CardHeader
                        className="pb0"
                        avatar={
                            <img src={clientSnapshot} alt="#" />
                        }
                        title={<React.Fragment>
                            <Typography
                                    component="span"
                                    variant="body1"
                            >
                                <strong>Quick View&nbsp;-&nbsp;{completedPolicyYearCount ? `(Policy Year ${completedPolicyYearCount})` : ""}&nbsp;({yearBetween})</strong>
                            </Typography>
                            <Typography
                                    className="textValue floatLeft w100"
                                    variant="caption"
                            >
                                Important details at a glance.
                            </Typography>
                        </React.Fragment>}
                />
                <CardContent className="floatLeft w100">
                    <List className="ClientDetailsList">
                        <li>
                            <label>Next Payment Due Date</label>
                            <span className="labelValue">
                                 {nextContributionDate ? moment(nextContributionDate).format("MM/DD/YYYY") : <span style={{color: "#3cda93"}}>Paid in full</span>}
                            </span>
                        </li>

                        <li>
                            <label> { (paymentFrequency === "monthly" ? "Monthly" : "Annual") + " Amount Owed "}</label>
                            <span className="labelValue colorBlue">
                                 { nextContributionAmount ? numeral(nextContributionAmount).format("$0,0.00") : <span style={{color: "#3cda93"}}>No payment due</span>}
                            </span>
                        </li>

                        <li>
                            <label>Policy Anniversary Date</label>
                            <span className="labelValue">{asDbDateFormat(anniversaryDate, DATE_FORMAT_SERVICE_DASHBOARD)}</span>
                        </li>

                        <li>
                            <label>Your { (paymentFrequency === "monthly" ? "Monthly" : "Annual") + " Contribution "}</label>
                            <span className="labelValue colorBlue">
                                 { nextContributionAmount ? numeral(nextContributionAmount).format("$0,0.00") : <span style={{color: "#3cda93"}}>No payment due</span>}
                            </span>
                        </li>

                        <li>
                            <label>Net Death Benefit</label>
                            <span className="labelValue">
                                <NumberFormat
                                        value={deathBenefit || 0}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                        decimalSeparator={"."}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                />
                            </span>
                        </li>

                        {employerContribution > 0 &&
                        <li>
                            <label>Annual Employer Contribution</label>
                            <span className="labelValue">
                                <NumberFormat
                                    value={employerContribution}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                    decimalSeparator={"."}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                />
                            </span>
                        </li>
                        }
                        <li>
                            <label>Net Cash Value</label>
                            <span className="labelValue">
                                <NumberFormat
                                    value={netCashValue}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                    decimalSeparator={"."}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                />
                            </span>
                        </li>

                        <li>
                            <label>Net Loan Balance</label>
                            <span className="labelValue">
                                <NumberFormat
                                        value={bankLoanAmount}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                        decimalSeparator={"."}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                />
                            </span>
                        </li>

                        <li>
                            <label>Potential Income at age ({potentialIncomeStartAge}-{potentialIncomeEndAge})</label>
                            <span className="labelValue">
                                <NumberFormat
                                        value={estimatedAnnualIncome || 0}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                        decimalSeparator={"."}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                />
                            </span>
                        </li>

                        <li>
                            <label>Carrier</label>
                            <span className="labelValue">
                                {carrierName}
                            </span>
                        </li>
                        {
                            companyName &&
                            <li>
                            <label>Group Name</label>
                            <span className="labelValue">
                            {companyName}
                            </span>
                        </li>
                        }
                        {/* for demo agent name is grace barnard */}
                        <li>
                            <label>Agent</label>
                            <span className="labelValue">
                            {agentName}
                            </span>
                        </li>

                        {
                        isEmployerContribution &&
                        <li>
                            <label>Employer - {isEmployerContribution}</label>
                            <span className="labelValue">
                            {employer}
                            </span>
                        </li>
                        }

                        <li>
                            <label className="mt15"><strong>Need Assistance?</strong></label>
                            <Button size="small" variant="outlined" color="primary" className="floatRight mt10" onClick={()=>{
                                history.push("/client/contactus");
                                accountActions.refresh();
                            }}>
                                Contact Us
                            </Button>
                        </li>
                    </List>
                </CardContent>
            </Card>
    );
}